import variables from '../variables';

const MuiButton = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      borderRadius: 16.5,
      textTransform: 'none',
      ...variables.typography.body2,
    },
    contained: {
      color: variables.colors.white,
    },
    outlinedSecondary: {
      borderColor: variables.colors.midGrey1,
    },
    outlinedPrimary: {
      backgroundColor: variables.colors.white,
    },
    sizeLarge: {
      ...variables.typography.h6,
      paddingTop: 5,
      paddingBottom: 5,
      borderRadius: 30,
    },
    sizeMedium: {
      ...variables.typography.h8,
      borderRadius: 16.5,
    },
  },
};

export default MuiButton;
